import React from "react";
import "../css/ColoredBlock.css";
import SignUp from "./SignUp";

function ColoredSignUp({ color }) {
  return (
    <div className="colored-block__div" style={{ backgroundColor: color }}>
      <div className="colored-block__text">
        <SignUp></SignUp>
      </div>
    </div>
  );
}

export default ColoredSignUp;
